import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazonawsComponent } from './simple-icons-amazonaws.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazonawsComponent ],
    exports:      [ SimpleIconsAmazonawsComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazonawsModule {}
